// source: pbtypes/vehicle/skills/actions/weather_action/weather_action.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_sim_simulator_disturbances_pb = require('../../../../../pbtypes/sim/simulator/disturbances_pb.js');
goog.object.extend(proto, pbtypes_sim_simulator_disturbances_pb);
var pbtypes_dock_weather_testing_weather_testing_pb = require('../../../../../pbtypes/dock/weather_testing/weather_testing_pb.js');
goog.object.extend(proto, pbtypes_dock_weather_testing_weather_testing_pb);
goog.exportSymbol('proto.skills.WeatherActionArgs', null, global);
goog.exportSymbol('proto.skills.WeatherActionArgs.RequestCase', null, global);
goog.exportSymbol('proto.skills.WeatherActionResultData', null, global);
goog.exportSymbol('proto.skills.WeatherActionStateData', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.WeatherActionArgs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.skills.WeatherActionArgs.oneofGroups_);
};
goog.inherits(proto.skills.WeatherActionArgs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.WeatherActionArgs.displayName = 'proto.skills.WeatherActionArgs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.WeatherActionResultData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.WeatherActionResultData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.WeatherActionResultData.displayName = 'proto.skills.WeatherActionResultData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.WeatherActionStateData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.WeatherActionStateData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.WeatherActionStateData.displayName = 'proto.skills.WeatherActionStateData';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.skills.WeatherActionArgs.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.skills.WeatherActionArgs.RequestCase = {
  REQUEST_NOT_SET: 0,
  DISTURBANCE_REQUEST: 1,
  RAIN_REQUEST: 2
};

/**
 * @return {proto.skills.WeatherActionArgs.RequestCase}
 */
proto.skills.WeatherActionArgs.prototype.getRequestCase = function() {
  return /** @type {proto.skills.WeatherActionArgs.RequestCase} */(jspb.Message.computeOneofCase(this, proto.skills.WeatherActionArgs.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.WeatherActionArgs.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.WeatherActionArgs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.WeatherActionArgs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.WeatherActionArgs.toObject = function(includeInstance, msg) {
  var f, obj = {
disturbanceRequest: (f = msg.getDisturbanceRequest()) && pbtypes_sim_simulator_disturbances_pb.DisturbanceRequest.toObject(includeInstance, f),
rainRequest: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
timeout: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.WeatherActionArgs}
 */
proto.skills.WeatherActionArgs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.WeatherActionArgs;
  return proto.skills.WeatherActionArgs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.WeatherActionArgs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.WeatherActionArgs}
 */
proto.skills.WeatherActionArgs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_sim_simulator_disturbances_pb.DisturbanceRequest;
      reader.readMessage(value,pbtypes_sim_simulator_disturbances_pb.DisturbanceRequest.deserializeBinaryFromReader);
      msg.setDisturbanceRequest(value);
      break;
    case 2:
      var value = /** @type {!proto.weather_testing.RainRigCommand.RainRigCommandType} */ (reader.readEnum());
      msg.setRainRequest(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTimeout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.WeatherActionArgs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.WeatherActionArgs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.WeatherActionArgs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.WeatherActionArgs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisturbanceRequest();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_sim_simulator_disturbances_pb.DisturbanceRequest.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.weather_testing.RainRigCommand.RainRigCommandType} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getTimeout();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
};


/**
 * optional simulator.DisturbanceRequest disturbance_request = 1;
 * @return {?proto.simulator.DisturbanceRequest}
 */
proto.skills.WeatherActionArgs.prototype.getDisturbanceRequest = function() {
  return /** @type{?proto.simulator.DisturbanceRequest} */ (
    jspb.Message.getWrapperField(this, pbtypes_sim_simulator_disturbances_pb.DisturbanceRequest, 1));
};


/**
 * @param {?proto.simulator.DisturbanceRequest|undefined} value
 * @return {!proto.skills.WeatherActionArgs} returns this
*/
proto.skills.WeatherActionArgs.prototype.setDisturbanceRequest = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.skills.WeatherActionArgs.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.WeatherActionArgs} returns this
 */
proto.skills.WeatherActionArgs.prototype.clearDisturbanceRequest = function() {
  return this.setDisturbanceRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.WeatherActionArgs.prototype.hasDisturbanceRequest = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional weather_testing.RainRigCommand.RainRigCommandType rain_request = 2;
 * @return {!proto.weather_testing.RainRigCommand.RainRigCommandType}
 */
proto.skills.WeatherActionArgs.prototype.getRainRequest = function() {
  return /** @type {!proto.weather_testing.RainRigCommand.RainRigCommandType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.weather_testing.RainRigCommand.RainRigCommandType} value
 * @return {!proto.skills.WeatherActionArgs} returns this
 */
proto.skills.WeatherActionArgs.prototype.setRainRequest = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.skills.WeatherActionArgs.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.skills.WeatherActionArgs} returns this
 */
proto.skills.WeatherActionArgs.prototype.clearRainRequest = function() {
  return jspb.Message.setOneofField(this, 2, proto.skills.WeatherActionArgs.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.WeatherActionArgs.prototype.hasRainRequest = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional float timeout = 3;
 * @return {number}
 */
proto.skills.WeatherActionArgs.prototype.getTimeout = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.WeatherActionArgs} returns this
 */
proto.skills.WeatherActionArgs.prototype.setTimeout = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.WeatherActionResultData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.WeatherActionResultData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.WeatherActionResultData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.WeatherActionResultData.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.WeatherActionResultData}
 */
proto.skills.WeatherActionResultData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.WeatherActionResultData;
  return proto.skills.WeatherActionResultData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.WeatherActionResultData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.WeatherActionResultData}
 */
proto.skills.WeatherActionResultData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.WeatherActionResultData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.WeatherActionResultData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.WeatherActionResultData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.WeatherActionResultData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.WeatherActionStateData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.WeatherActionStateData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.WeatherActionStateData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.WeatherActionStateData.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.WeatherActionStateData}
 */
proto.skills.WeatherActionStateData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.WeatherActionStateData;
  return proto.skills.WeatherActionStateData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.WeatherActionStateData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.WeatherActionStateData}
 */
proto.skills.WeatherActionStateData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.WeatherActionStateData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.WeatherActionStateData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.WeatherActionStateData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.WeatherActionStateData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.skills);
